import { Typography } from '@material-ui/core';
import classNames from 'classnames';

import Button from '@components/common/button';
import Figures, { Image } from '@components/common/figures';
import useStyles from '@components/common/plans/styles';

interface PlanAction {
  href: string;
  text: string;
}

interface PlanPrice {
  text: string;
  value: string;
}

interface PlanFeatures {
  enabled?: boolean;
  text: string;
}

export interface PlanInfo {
  action?: PlanAction;
  features: PlanFeatures[];
  prices: PlanPrice[];
  title: string;
  withBorder?: boolean;
}

interface Props {
  info: PlanInfo[];
}

const Plans: React.FC<Props> = (props) => {
  const { info } = props;

  const classes = useStyles();

  const plansImages: Image[] = [
    {
      src: '/png/person-meditating.png',
      classWrapper: classes.personMeditating,
    },
  ];
  const plans = info.map((plan) => (
    <div
      className={classNames(classes.plan, {
        [classes.withBorder]: plan.withBorder,
      })}
      key={plan.title}
    >
      {plan.title && <Typography variant="subtitle1">{plan.title}</Typography>}
      {plan.prices && (
        <div
          className={classNames(classes.pricesWrapper, {
            [classes.twoColumns]: plan.prices.length >= 2,
          })}
        >
          {plan.prices.map((price) => (
            <div className={classes.price} key={`${plan.title} ${price.value}`}>
              <Typography variant="h3">{price.value}</Typography>
              <Typography variant="body2">{price.text}</Typography>
            </div>
          ))}
        </div>
      )}

      {plan.features && (
        <div className={classes.featuresWrapper}>
          {plan.features.map((feature) => (
            <div
              className={classes.feature}
              key={`${plan.title} ${feature.text}`}
            >
              <i
                className={classNames({
                  'icon-checki-in-circle': feature.enabled,
                  [classes.green]: feature.enabled,
                  'icon-cross': !feature.enabled,
                  [classes.red]: !feature.enabled,
                })}
              />
              <Typography
                className={classNames({ [classes.disabled]: !feature.enabled })}
                variant="body2"
              >
                {feature.text}
              </Typography>
            </div>
          ))}
        </div>
      )}
      {plan.action && (
        <Button
          id="start-for-free-button-plans"
          fullWidthOnMobile
          styleType="containedBlue"
          className={classes.button}
          text={plan.action.text}
          href={plan.action.href}
        />
      )}
    </div>
  ));

  return (
    <section className={classNames(classes.plansWrapper)}>
      {plans}
      <Figures
        classWrapper={classes.planImages}
        images={plansImages}
        circles={[]}
      />
    </section>
  );
};

export default Plans;
